import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import CommerceOnly from '/src/_includes/commerce-only.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <CommerceOnly mdxType="CommerceOnly" />
    <h1 {...{
      "id": "company-b2b-mutations"
    }}>{`Company (B2B) mutations`}</h1>
    <p>{`The B2B company mutations allow you to perform the management operations:`}</p>
    <ul>
      <li parentName="ul">{`Create and update a company.`}</li>
      <li parentName="ul">{`Create, update, and delete company users.`}</li>
      <li parentName="ul">{`Create, update, and delete company teams.`}</li>
      <li parentName="ul">{`Move the position of a company team in the company hierarchy.`}</li>
      <li parentName="ul">{`Create, update, and delete company roles.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      